import { FetchesData } from "kinnect-mixins";
import {
	KAutocomplete,
	KForm,
	KTextField,
	KTextarea
} from "kinnect-general";
import { TransactionErrorType } from "kinnect-models";
import { formatCurrency } from "kinnect-formatters";

export default KForm.extend( {
	name: "KTripErrorForm",

	mixins: [ FetchesData ],

	props: {
		idTrip: Number,
		tripError: Object
	},

	data: () => ( {
		errorTypes: [],
		formFields: {
			cost: null,
			error: null,
			errorTypes: []
		}
	} ),

	computed: {
		editing() {
			return Boolean( this.tripError );
		},

		formUrl() {
			const baseUrl = `yard/trips/${this.idTrip}/errors`;

			return this.editing ? `${baseUrl}/${this.tripError.id}` : baseUrl;
		},

		internalRedirect() {
			if ( this.redirect ) {
				return this.redirect;
			}

			return [ "back", {
				name: "yardTrips",
				params: { idTrip: this.idTrip }
			} ];
		}
	},

	watch: {
		tripError: {
			handler( tripError ) {
				if ( tripError ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( tripError.hasOwnProperty( key ) && key !== "errorTypes" ) {
							this.formFields[key] = tripError[key];
						}
					} );

					this.formFields.errorTypes = tripError.errorTypes.map( item => item.id );
				}
			},
			immediate: true
		}
	},

	methods: {
		async fetchErrorTypes() {
			this.errorTypes = await TransactionErrorType.get();
		},

		async fetch() {
			await this.fetchErrorTypes();
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				attrs: this.$attrs,
				data: this.formFields,
				method: this.editing ? "put" : "post",
				redirect: this.internalRedirect
			}}
			on={this.$listeners}
		>
			<KAutocomplete
				chips
				class="ml-blank-icon"
				deletableChips
				groupBy="category"
				itemText="name"
				itemValue="id"
				items={this.errorTypes}
				label="Error Type(s)*"
				loading={this.$wait.is( "get transaction error types" )}
				multiple
				required
				vModel={this.formFields.errorTypes}
				validationName="error type(s)"
				validationRules="required"
			></KAutocomplete>

			<KTextField
				hint={this.formFields.cost ? formatCurrency( this.formFields.cost ) : ""}
				label="Error Cost"
				onInput={val => this.formFields.cost = val ? parseFloat( val ) : null}
				persistentHint
				prependIcon="attach_money"
				type="number"
				validationName="error cost"
				validationRules="min_value:0"
				value={this.formFields.cost}
			></KTextField>

			<KTextarea
				label="Error Notes*"
				prependIcon="comment"
				required
				vModel={this.formFields.error}
				validationName="error notes"
				validationRules="required"
			></KTextarea>
		</KForm>;
	}
} );
